export default __webpack_public_path__ + "static/media/lynn-artworkinfo1.973a97ee.png";